<script>
import OrdersPage from '@/components/profile/OrdersPage.vue';
import VRuntimeTemplate from 'vue3-runtime-template';
import LoginModal from '@/components/modals/LoginModal.vue';
import RequisitesPage from '@/components/profile/RequisitesPage.vue';
import FavoritePage from '@/components/cart/FavoritePage.vue';
import FormComponent from '@/components/forms/FormComponent.vue';
import OrderPage from '@/components/cart/OrderPage.vue';
import {togglePassword} from "@/helpers/togglePassword.ts";
// @ts-ignore

export default {
  name: 'DynamicCache',
  components: {
    OrdersPage,
    OrderPage,
    VRuntimeTemplate,
    LoginModal,
    RequisitesPage,
    FavoritePage,
    FormComponent
  },
  data() {
    return {
      html: '',
      hideSlot: false
    };
  },
  mounted() {
    const _this = this;

    document.addEventListener('afterBlitzInject', function (e) {
      if (e.detail.element.id !== _this.$slots.default()[0].props.id) {
        return;
      }

      _this.html = document.querySelector(`#${e.detail.element.id}`).innerHTML;

      setTimeout(() => {
        _this.hideSlot = true;

        togglePassword()
      }, 0);
    });
  }
};
</script>

<template>
  <div v-if="!hideSlot">
    <slot></slot>
  </div>
  <v-runtime-template :template="html"/>
</template>
